import React, { Component } from 'react'
import {db} from '../../config/fbConfig'
import BlogContent from './blogContent'
import { Helmet } from 'react-helmet'
import './blogDashboard.css'

class BlogDashboard extends Component {

    state={
        blogs:'',
    }

    componentDidMount(){
        db.collection('blogs')
        .get()
        .then(snapshot => {
            const blogs = []
            snapshot.forEach(doc=>{
                const data = doc.data()
                blogs.push(data)
            })
            this.setState({blogs :blogs})
        })
        .catch(err =>{
            console.log(err)
        })
    }
    render() {
        return (
            <>
            <div className='dashboard-wrapper'>
            <Helmet>
                <title>Blogs on Indian History, Culture and Philosophy</title>
                <meta name="description" content="Explore the wide and glorious history of the Indian subcontinent"></meta>
            </Helmet>
            <h1>Check out amazing Blogs on Indian History, Culture and Philosophy</h1>
            <div className='dashboard-container'>
                {
                    this.state.blogs && this.state.blogs.map(blog=>{
                        return(
                                <BlogContent blog={blog}/>
                        )
                    })
                }
            </div>
            </div>
            </>
        )
    }
}


export default BlogDashboard
